import { useState, useEffect } from 'react';
import { Modal } from 'bootstrap';
import { useNavigate } from "react-router-dom";
import clientHttp from '../../components/ClientHttp';
import Pagination from '../../components/Pagination';
import BankAccountList from './BankAccountList';
import { getBankAccountList, getBankNoList } from '../../components/DataList';

export default function BankAccountContent() {
    const [data, setData] = useState(null);
    const [isSearchLoading, setIsSearchLoading] = useState(false)
    const [error, setError] = useState('');
    const [errorClass, setErrorClass] = useState('');

    let navigate = useNavigate()
    
    // change page
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(0)
    const [pageSize, setPageSize] = useState(10);
    const onPageChange = (page) => {
        setCurrentPage(page);
        console.log('select page: ' + page)
        searchSubmit(page)
    }
    const selectPageSize = (e) => { setPageSize(e.target.value) }

    // bank
    const [bank, setBank] = useState('ALL')
    const [bankNo, setBankNo] = useState('ALL')
    const selectBank = (e) => {
        setBank(e.target.value)
    }
    const selectBankNo = (e) => {
        setBankNo(e.target.value)
    }

    async function searchSubmit(page) {
        setCurrentPage(page);
        setIsSearchLoading(true)
        let isSuccess = false
        // clear data
        setError('')
        setErrorClass('')
        setData(null)

        // prepare parameters
        console.log('call search api with parameters:' + bank, bankNo, page, pageSize)
        const formData = {
            bank: bank,
            bankNo: bankNo,
            page: page,
            pageSize: pageSize,
        }
        console.log(formData)

        // call search api
        let token = localStorage.getItem('token')
        await clientHttp.post('setting/v1/bankaccount_info', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            console.log('response status: ' + response.status)
            if (response.data.status === 'success') {
                console.log('display bank account info list')
                setTotal(response.data.total)
                setData(response.data.data)
                //console.log(response)
                isSuccess = true
                setErrorClass('text-black')
            } else {
                console.log('get bank account info list failed: ' + response.data.message)
                setError(response.data.message)
                setErrorClass('text-danger')
            }

        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('get bank account info list failed: ' + err.message)
                setError(err.message)
                setErrorClass('text-danger')
            }
        })

        if (!isSuccess) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        }
        setIsSearchLoading(false)
    }

    // load data list for dropdown
    const [bankNameList, setBankNameList] = useState([])
    const [bankNoList, setBankNoList] = useState([])
    useEffect(() => {
        // get bank list
        (async () => {
            console.log('load bank list')
            setBankNameList(await getBankAccountList())
        })()

    }, [])

    useEffect(() => {
        if (bank && bank !== 'ALL') {
            (async () => {
                console.log('load bank no of ' + bank)
                let list = await getBankNoList(bank)
                console.log(list)
                setBankNoList(list)
            })()
        }
    }, [bank])

    return (
        <>
            <div className="page-header">
            </div>
            <div className="row">
                <div className="col-md-12">
                    {/* start form */}
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">Bank:</span>
                                            <select className="form-select" value={bank} onChange={selectBank}>
                                                <option value="ALL">All</option>
                                                {
                                                    bankNameList?.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.bankabv}>{item.bankabv}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <span className="input-group-text">Bank No:</span>
                                            <select className="form-select" value={bankNo} onChange={selectBankNo}>
                                                <option value="ALL">All</option>
                                                {
                                                    bankNoList?.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.bankno}>{item.bankno}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-1 col-md-1 col-sm-1">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <select className="form-select" defaultValue={pageSize} onChange={selectPageSize}>
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="500">500</option>
                                                <option value="1000">1000</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                    <div className="form-group">
                                        {isSearchLoading ?
                                            <button className="btn btn-black btn-border btn-primary" style={{ "width": "120px" }} type="button">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                <span role="status" className="ms-3">Loading...</span>
                                            </button>
                                            :
                                            <button type="button" className="btn btn-primary" style={{ "width": "120px" }} onClick={searchSubmit.bind(this, 1)}>
                                                <i className="bi bi-search me-2"></i> Search
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* end form */}
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    {data && <BankAccountList data={data} searchSubmit={searchSubmit} currentPage={currentPage} />}
                </div>
            </div>

            {data &&
                <Pagination total={total} pageSize={pageSize} currentPage={currentPage} onPageChange={onPageChange} />
            }

            <div className='row'>
                <div className='col-md-12'>
                    <div className="modal fade" id="errorMessageModal" tabIndex="-1" >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <p className={errorClass}>{error}</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}